import React from 'react';

const Result = ({obj}) => {
    return (
        <>
            {obj.imc ? (
            <>
                {obj.imc}&nbsp; <small> Mg/Dl</small>
            </>
            ) : null}
            {obj.glicemia ? (
                <>
                    {obj.glicemia}&nbsp; <small> Mg/Dl</small>
                </>
            ) : null}
            {obj.name === 'Presion arterial' ? (
                <>
                    {obj.sistolica_bi}/{obj.diastolica_bi}&nbsp; <small> Mg/Dl</small>
                </>
            ) : null}
            {obj.name === "Perfil Lipídico" ? (
                <>
                <div className="div_results_pl">
                    <small>Colesterol</small> <br/>
                    {obj.colesterol}<br/> <small> Mg/Dl</small>
                </div>
                <div className="div_results_pl">
                    <small>Trigliceridos</small> <br/>
                    {obj.trigliceridos}<br/> <small> Mg/Dl</small>
                </div>
                </>
            ): null}
        </>    
    )
}
 
export default Result;